<template>
  <v-row>
    <v-col class="fw-bold">
      {{i18n.global.t('pages.firmwareBulkUpdate.applyDate.name')}}
      <span style="color: red">✴︎</span>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <ValidationErrors :messages="errorMessages">
        <VueDatePicker
          class="mb-0"
          :formats="{ input: 'yyyy-MM-dd HH:mm:ss' }"
          :locale="ja"
          v-model="applyDate"
        />
      </ValidationErrors>

    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import i18n from '@/lang/i18n';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: Date
  errorMessages: string[]
}>()

const applyDate = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

</script>
